import { Box, Typography } from '@mui/material'
import { IFile } from 'src/generated-types/file'
import { FileUrlLoader } from '../input/CommonFileUploader'

interface FilePreviewGridProps {
  files: IFile[]
  onFileClick: (file: IFile) => void
}

const FilePreviewGrid: React.FC<FilePreviewGridProps> = ({ files, onFileClick }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' },
        gap: 2,
      }}
    >
      {files.map((file) => {
        const isImage = file.contentType?.includes('image')
        const shortenedName = file.filename.length > 25 ? file.filename.substring(0, 22) + '...' : file.filename
        
        return (
          <Box
            key={file.id}
            onClick={(e) => {
              e.stopPropagation()
              onFileClick(file)
            }}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              height: 45,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              overflow: 'hidden',
              cursor: 'pointer',
              transition: 'all 0.2s',
              '&:hover': {
                boxShadow: 2,
                borderColor: 'primary.main',
              },
            }}
          >
            {isImage ? (
              <Box
                sx={{
                  width: 60,
                  alignSelf: 'stretch',
                  flexShrink: 0,
                  bgcolor: 'grey.100',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={file.url}
                  alt={file.filename}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  width: 60,
                  alignSelf: 'stretch',
                  flexShrink: 0,
                  bgcolor: 'grey.50',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <FileUrlLoader contentTypeValue={file.contentType} fileUrl={file.url} openOnClick={false} className="text-[24px] h-[24px] w-[24px]" />
              </Box>
            )}
            <Box sx={{ px: 1, py: 0.25, minWidth: 0, flex: 1 }}>
              <Typography variant="caption" fontWeight={600} sx={{ mb: 0, display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.7rem', lineHeight: 1.2 }} title={file.filename}>
                {shortenedName}
              </Typography>
              {file.contentType && (
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem', lineHeight: 1.2 }}>
                  {file.contentType.split('/')[1]?.toUpperCase()}
                </Typography>
              )}
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default FilePreviewGrid
